import fetchQcEventHistory from "./qrEventHistory.api";

const CreditReportingApi = {
  fetchQcEventHistory
};

export default CreditReportingApi;